<template>
  <page>
    <v-flex xs12>
      <form>
        <v-expansion-panels>
          <v-expansion-panel>
            <v-expansion-panel-header>
              <div><v-icon>mdi-filter-variant</v-icon> Filters</div>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl6 lg6 xs12>
                        <v-text-field
                          v-model="filter.id"
                          :label="label.id"
                          :error-messages="errors.collect('filter.id')"
                          data-vv-name="filter.id"
                          :data-vv-as="label.id"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <v-text-field
                          v-model="filter.customName"
                          :label="label.customName"
                          :error-messages="errors.collect('filter.customName')"
                          data-vv-name="filter.customName"
                          :data-vv-as="label.customName"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <v-autocomplete
                          :items="statusCodeList"
                          v-model="filter.statusCode"
                          item-text="label"
                          item-value="value"
                          :label="label.statusCode"
                          :error-messages="errors.collect('filter.statusCode')"
                          data-vv-name="filter.statusCode"
                          :data-vv-as="label.statusCode"
                          clearable
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex xl6 lg6 xs12>
                        <cal-picker
                          v-model="filter.createdDate"
                          :label="label.createdDate"
                          :data-vv-as="label.createdDate"
                          data-vv-name="filter.createdDate"
                        ></cal-picker>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                  <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </form>
    </v-flex>
    <v-spacer class="mt-2"></v-spacer>
    <v-card>
      <v-flex xs12>
        <v-tabs v-model="tabsNav">
          <v-tab>Reports</v-tab>
          <v-tooltip top v-if="checkedItems.length > 0">
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" fab dark small color="error" v-on="on" @click.native="promptRemoveSelected = true">
                <v-icon dark>mdi-delete</v-icon>
              </v-btn>
            </template>
            <span>{{ label.delete }}</span>
          </v-tooltip>
          <v-tooltip top v-if="showBtn && checkedItems.length > 0">
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" fab dark small color="info" v-on="on" @click.native="promptRead = true">
                <v-icon dark>mdi-check</v-icon>
              </v-btn>
            </template>
            <span>{{ label.mark }}</span>
          </v-tooltip>
          <v-tooltip top v-if="showBtn">
            <template v-slot:activator="{ on }">
              <v-btn class="mx-2" fab dark small color="primary" v-on="on" @click.native="promptAllRead = true">
                <v-icon dark>mdi-check-all</v-icon>
              </v-btn>
            </template>
            <span>{{ label.markAll }}</span>
          </v-tooltip>
        </v-tabs>
        <v-tabs-items v-model="tabsNav" touchless>
          <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory">
            <v-card>
              <v-data-table
                :headers="headers"
                :items="items"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItems"
                v-bind:options.sync="pagination"
                item-key="id"
                :loading="loading"
                :no-data-text="noDataText"
                show-select
                v-model="checkedItems"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      <v-checkbox v-model="checkedItems" :value="row.item" style="margin:0px;padding:0px;" hide-details />
                    </td>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      {{ row.item.id }}
                    </td>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      {{ row.item.customName }}
                    </td>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      {{ row.item.fileFormat }}
                    </td>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      {{ formatDate(row.item.createdDate) }}
                    </td>
                    <td :class="row.item.downloaded ? 'text-xs-left' : 'not-download'">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <v-icon v-on="on" :color="row.item.color">{{ row.item.icon }}</v-icon>
                        </template>
                        <span>{{ row.item.statusDesc }}</span>
                      </v-tooltip>
                    </td>
                    <td :class="row.item.downloaded ? 'table-action-header' : 'table-action-header not-download'">
                      <table-action
                        :rowData="row"
                        :download="canDownload(row.item)"
                         @download="doDownload(row.item)"
                        :error="showError(row.item)"
                        @error="showErrorDialog(row.item)"
                        remove
                        @remove="doPromptRemove(row.item)"
                        :report_param="true"
                        @report_param="doReportParam(row.item)"
                        :retry="canRetry(row.item)"
                        @retry="doRetry(row.item)"
                      ></table-action>
                    </td>
                  </tr>
                </template>
              </v-data-table>
            </v-card>
          </v-tab-item>
        </v-tabs-items>
      </v-flex>
    </v-card>
    <v-dialog v-model="errorDialog" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>System Information</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text>
          <div v-if="selectedJob" class="pb-3">
            <v-subheader>Oops something went wrong:</v-subheader>
            <ul class="showErrorMsgs">
              <li>
                {{ selectedJob.errorMsg }}
              </li>
            </ul>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="errorDialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="downloading" hide-overlay persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Downloading
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <confirm v-model="promptRemove" @ok="doDelete">
      <p>Are you sure you want to delete the selected Report Job?</p>
      <div class="queryValue">RptJob ID: {{ selectedJob.id }}</div>
      <div class="queryValue">Report Name: {{ selectedJob.customName }}</div>
    </confirm>
    <confirm v-model="promptAllRead" @ok="flagAllRead">
      Are you sure you want to mark all as downloaded?
    </confirm>
    <confirm v-model="promptRead" @ok="flagRead">
      Are you sure you want to mark as downloaded?
    </confirm>
    <confirm v-model="promptRemoveSelected" @ok="doDeleteSelected">
      Are you sure you want to delete the report(s)?
    </confirm>
    <v-dialog v-model="showReportParam" width="800px">
      <v-card>
        <v-toolbar dense color="grey lighten-3" flat>
          <v-icon>mdi-information</v-icon>
          <v-toolbar-title>Report Run Time Parameters</v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
        <v-card-text v-if="selectedJob">
          <pre class="wrap-pre">{{ selectedJob.rptKeys }}</pre>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click.native="showReportParam = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import { downloadPrompt } from '@/utils/file'
import clone from 'clone'
import { statusCode } from '@/const/common'

export default {
  data() {
    return {
      headers: [
        { text: 'Job ID', value: 'id' },
        { text: 'Document Name', value: 'customName' },
        { text: 'File Format', value: 'fileFormat' },
        { text: 'Generated Date', value: 'createdDate' },
        { text: 'Report Status', value: 'statusCode' },
        TableConst.tableActionHeader
      ],
      selectedJob: {
        id: null,
        customName: undefined,
        errorMsg: undefined
      },
      promptRemove: false,
      promptRemoveSelected: false,
      label: {
        id: 'Job ID',
        customName: 'Report Name',
        statusCode: 'Report Status',
        createdDate: 'Generated Date',
        mark: 'Mark as downloaded',
        markAll: 'Mark all as downloaded',
        delete: 'Delete'
      },
      filter: {
        id: null,
        customName: null,
        statusCode: null,
        createdDate: null
      },
      toogleArray: [false],
      totalItems: null,
      errorDialog: false,
      downloading: false,
      pagination: {
        sortDesc: [false],
        sortBy: [],
        page: 1
      },
      checkedItems: [],
      firstLoad: false,
      tabsNav: 0,
      showBtn: false,
      promptAllRead: false,
      promptRead: false,
      showReportParam: false,
      selectedUsrNotif: {}
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      if (this.$store.state.user.notification.init === 0) {
        await Promise.all([this.$store.dispatch('initNotification')])
      }
      this.showBtn = false
      const apiURI = this.menu.notifReports
      if (apiURI) {
        this.loading = true
        try {
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: false
          }
          let massageFilters = clone(this.filter)
          if (this.filter.createdDate === null) {
            massageFilters.createdDate = null
          }
          if (massageFilters.createdDate !== null && massageFilters.createdDate !== '') {
            massageFilters.createdDate = formatDisplayDateTime2(removeTime(massageFilters.createdDate))
          }
          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), massageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          this.items = []
          if (result.data) {
            const { data } = result.data
            this.totalItems = result.data.totalElements
            if (data) {
              data.map(rptJob => {
                const convertList = {
                  id: rptJob.id,
                  customName: rptJob.customName,
                  statusDesc: rptJob.statusDesc,
                  fileFormat: rptJob.fileFormat,
                  createdDate: rptJob.createdDate,
                  downloaded: rptJob.downloaded,
                  errorMsg: rptJob.errorMsg,
                  color: rptJob.color,
                  icon: rptJob.icon,
                  rptKeys: rptJob.rptKeys,
                  statusCode: rptJob.statusCode
                }
                this.items.push(this.getStatus(convertList))
                this.firstLoad = true
                if (!rptJob.downloaded) {
                  this.showBtn = true
                }
              })
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.checkedItems = []
    },
    getStatus(convertList) {
      let massageConvertList = clone(convertList)
      if (convertList.statusCode === 'N' || convertList.statusCode === 'P') {
        massageConvertList.status = 0
      } else if (convertList.statusCode === 'C') {
        massageConvertList.status = 1
      } else {
        massageConvertList.status = 2
      }
      return massageConvertList
    },
    doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        this.promptRemove = true
        this.selectedJob.id = data.id
        this.selectedJob.customName = data.customName
      }
    },
    async doPromptRemoveSelect(data) {
      this.resetMessages()
      this.promptRemove = true
      if (data) {
        this.selectedUsrNotif = data
      }
    },
    doDelete() {
      if (this.selectedJob.id) {
        const apiURI = this.menu.deleteRptJob
        if (apiURI) {
          const expand = {
            id: this.selectedJob.id
          }
          this.$http
            .post(apiURI, expand)
            .then(result => {
              const data = result.data
              this.notify(data)
              this.doInit(true)
            })
            .catch(err => {
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    },
    async doDeleteSelected() {
      const apiURI = this.menu.deleteUsrReport
      if (apiURI) {
        let expand = {}
        if (Object.keys(this.selectedUsrNotif).length > 0) {
          expand = {
            id: this.selectedUsrNotif.id
          }
        } else {
          if (this.checkedItems.length > 0) {
            let ids = []
            this.checkedItems.map(item => {
              ids.push(item.id)
            })
            expand = {
              id: ids.join()
            }
          }
          this.$http
            .post(apiURI, expand)
            .then(result => {
              const data = result.data
              this.notify(data)
              this.promptRemoveSelected = false
              this.doInit()
            })
            .catch(err => {
              this.promptRemoveSelected = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
          this.selectedUsrNotif = {}
        }
      }
      this.checkedItems = []
    },
    async doDownload(job) {
      this.selectedJob = job
      if (this.selectedJob) {
        const apiURI = this.menu.rptDownload
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            this.downloading = true

            const result = await this.$http.get(expandURI(apiURI, expand), {
              responseType: 'blob'
            })
            var headers = result.headers
            var blob = new Blob([result.data], { type: headers['content-type'] })
            var filename = (headers['content-disposition'] || 'file').split('filename=')[1]
            downloadPrompt(blob, filename)
            this.downloading = false
            this.$store.dispatch('getReportsCount')
            this.doInit()
          } catch (err) {
            const { data } = err.response
            if (data) {
              // As the request is requesting blob, error has to be formatted back to json
              try {
                const errUrl = URL.createObjectURL(data)
                const errRes = await this.$http.get(errUrl)
                URL.revokeObjectURL(errUrl)
                if (errRes.data) {
                  this.notify(errRes.data)
                }
              } catch (err2) {
                const { data } = err2.response
                this.notify(data)
              }
            }
            this.downloading = false
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    doClearFilters() {
      this.filter.id = null
      this.filter.customName = null
      this.filter.statusCode = null
      this.filter.createdDate = null
      this.doInit()
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.doInit()
        }
      })
    },
    showErrorDialog(data) {
      this.selectedJob.errorMsg = data.errorMsg
      this.errorDialog = true
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    formatDate2(date) {
      return formatDisplayDateTime2(date)
    },
    removeTime(date) {
      return removeTime(date)
    },
    canDownload(item) {
      return item.status === 1
    },
    canRetry(item) {
      return item.status === 2
    },
    showError(item) {
      return item.status === 2
    },
    doReportParam(job) {
      this.selectedJob = job
      this.showReportParam = true
    },
    async doRetry(job) {
      this.selectedJob = job
      if (this.selectedJob && this.selectedJob.status === 2) {
        const apiURI = this.$store.state.app.menu.rptReprocess
        if (apiURI) {
          try {
            const expand = {
              id: this.selectedJob.id
            }
            const result = await this.$http.post(expandURI(apiURI, expand))
            const { data } = result
            if (data.data) {
              const index = this.items.indexOf(this.items.find((job) => job.id === this.selectedJob.id))
              this.$set(this.items, index, this.getStatus(data.data))
            }
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        } else {
          this.notify('The request failed because it is trying to execute an invalid API url.')
        }
      }
    },
    async flagRead() {
      if (this.checkedItems.length > 0) {
        let ids = []
        this.checkedItems.map(item => {
          ids.push(item.id)
        })
        const apiUrl = this.menu.flagReportRead
        if (apiUrl) {
          try {
            let expand = {
              ids: ids.join()
            }
            await this.$http.post(expandURI(apiUrl, expand))
            this.$store.dispatch('getMessagesCount')
            this.doInit()
          } catch (err) {
            const { data } = err.response
            if (data) {
              this.notify(data)
            }
          }
        }
      }
    },
    async flagAllRead() {
      const apiUrl = this.menu.flagAllReportRead
      if (apiUrl) {
        try {
          await this.$http.post(apiUrl)
          this.$store.dispatch('getMessagesCount')
          this.doInit()
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.notify(data)
          }
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.user.notification.menu
    },
    statusCodeList() {
      let result = []
      Object.keys(statusCode).forEach(function(key) {
        const status = statusCode[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    }
  },
  watch: {
    pagination: function(value) {
      if (this.firstLoad) {
        this.doInit()
      }
    },
    '$store.state.user.notification.rptId': function (value) {
      if (value) {
        this.doInit()
      }
    },
    '$store.state.user.notification.rptStatus': function (value) {
      if (value) {
        this.doInit()
      }
    },
    '$store.state.user.notification.rptJobCount': function (value) {
      if (value) {
        this.doInit()
      }
    }
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
.not-download {
  text-align: left;
  font-weight: bold;
  background-color: rgb(240, 240, 240);
}
</style>
